import { ImageUpload } from './ImageUpload';
import styles from './styles.scss';
import { removeImage, replaceImage, addImage, ImageAction, SelectedImage } from './ImageHelper';

interface OwnProps {
  images: SelectedImage[];
  maxImageCount: number;
  dispatch: (action: ImageAction) => void;
  useZendesk?: boolean;
}

export const DynamicImageUploader = ({ images, maxImageCount, dispatch, useZendesk }: OwnProps) => {
  const _onChange = (id: string, imageUrl: string, token?: string) => {
    if (imageUrl === '') {
      removeImage(id, imageUrl, dispatch);
    } else if (images.some(img => img.id === id)) {
      replaceImage(id, imageUrl, dispatch, token);
    } else {
      addImage(id, imageUrl, dispatch, token);
    }
  };

  return (
    <div className={styles.upload}>
      {images.map(image => (
        <ImageUpload
          key={image.id}
          id={image.id}
          imageUrl={image.imageUrl}
          className={styles.uploadContainer}
          onChange={(id: string, imageUrl: string, token?: string) =>
            _onChange(id, imageUrl, token)
          }
          useZendesk={useZendesk}
        />
      ))}
      {images.length < maxImageCount && (
        <ImageUpload
          key={images.length + 1}
          imageUrl=""
          className={styles.uploadContainer}
          onChange={(id: string, imageUrl: string, token?: string) =>
            _onChange(id, imageUrl, token)
          }
          useZendesk={useZendesk}
        />
      )}
    </div>
  );
};
